import React, { useState, useEffect } from "react";
import {
  IonRow,
  IonCol,
  IonLabel,
  IonText,
  IonGrid,
  IonCheckbox,
} from "@ionic/react";
import { Days, PICKUP_DAYS_ERROR } from "../../../utils/constants";
import "./PickupDays.scss";

export interface IDay {
  label: string;
  value: string;
  selected: boolean;
}

export const PickupDays: React.FC<any> = (props: any) => {
  const list: Array<IDay> = Days.map((day: any) => {
    return {
      label: day.label.toLowerCase(),
      value: day.value,
      selected: false,
    };
  });

  const [daysList, setDaysList] = useState(list);
  const [allDaysSelected, setAllDaysSelected] = useState(false);
  const [showError, setError] = useState(false);
  useEffect(() => {
    if (props.preferredDays) {
      const daysList = list.map((day) => {
        return {
          ...day,
          selected: props.preferredDays.indexOf(day.value) !== -1,
        };
      });
      setDaysList(daysList);
      setAllDaysSelected(props.preferredDays.length === 7);
    }
  }, [props.preferredDays]);

  useEffect(() => {
    setError(props.showError);
  }, [props.showError]);
  const handleSubmit = (list: Array<IDay>) => {
    const selectedDays = list
      .filter((day: IDay) => day.selected)
      .map((day: IDay) => day.value);
    const isAllSelected = selectedDays.length === 7;
    setAllDaysSelected(isAllSelected);
    setDaysList(list);
    props.handleError(false);
    props.setPickupDays(selectedDays);
  };

  const handleClick = (selectedDay: IDay) => {
    const list = daysList.map((day: IDay) => {
      return {
        ...day,
        selected:
          day.label === selectedDay.label ? selectedDay.selected : day.selected,
      };
    });
    handleSubmit(list);
  };

  const handleAllClick = () => {
    const list = daysList.map((day: IDay) => ({
      ...day,
      selected: !allDaysSelected,
    }));
    handleSubmit(list);
  };
  return (
    <IonGrid className="pickupdays">
      <IonRow className="pickupdays-title-wrapper">
        <IonCol size="12">
          <IonLabel className="days-lbl">Select Days</IonLabel>
        </IonCol>
      </IonRow>
      <IonRow className="pickupday-wrapper">
        {daysList.map((day) => (
          <IonCol
            size="3"
            className={`pickupday checkbox-solid ${day.selected ? "checked" : "not-checked"}`}
            key={day.label}
          >
            <IonCheckbox
              checked={day.selected ? true : false}
              onClick={() => handleClick({ ...day, selected: !day.selected })}
              className="chb-pickup-days"
            />{" "}
            <IonLabel className="lbl-checkbox">{day.label}</IonLabel>
          </IonCol>
        ))}
        <IonCol
          className={`pickupday`}
          onClick={handleAllClick}
          data-test="handle-click"
        >
          <IonCheckbox
            checked={allDaysSelected ? true : false}
            onClick={handleAllClick}
            className="chb-pickup-days"
          />{" "}
          <IonLabel className="lbl-checkbox">All</IonLabel>
        </IonCol>
      </IonRow>
      {showError ? (
        <IonRow className="pickupdays-error-wrapper">
          <IonText class="pickupdays-error">{PICKUP_DAYS_ERROR}</IonText>
        </IonRow>
      ) : null}
    </IonGrid>
  );
};

export default PickupDays;
